<template>
  <div class="productDetailTab">
    <div class="detail_section">
      <PrdtName
        :dataName="allDetails"
        :showDiscountSnackbar="isShowSnackbar"
        :finalAmount="allDetails.finalPaidAmount"
        :cutAmountStyle="dataStyleAmount"
      />
    </div>
   
    <div class="limited_offer" v-if="allDetails.dealDisplayMessage">
      <Timer :timing="getLiveTime(allDetails.dealEndTimeMillis)" />
      <span class="msg_offer_time">{{allDetails.dealDisplayMessage}}</span>
    </div>
    <CutThePrice :dataCutThePrice="allDetails" @applycutprice="applycutprice" />
    <div
      class="detail_section"
      v-if="allDetails.selectableAttributes!= null && (allDetails.selectableAttributes.SIZE || allDetails.selectableAttributes.COLOR)"
    >
      <Color
        @saleReferenceID="saleReference_id"
        @ProductColor="ItemColor"
        @ProductSize="ItemSize"
        @Stock="StockData"
        :dataColor="allDetails"
      />
    </div>
    <div class="detail_section">
      <AboutProduct :dataAbtPrd="allDetails" />      
    </div>
    <div class="detail_section share_section">
      <ShareAndEarn :dataShareAndEarn="allDetails" v-if="!allDetails.cutPriceEnable" />
    </div>
    <div class="detail_section">
      <ProductPolicy :productPolicy="allDetails" />
    </div>
    <div class="detail_section">
      <h6 class="prdt_sub_hdng">
        {{$t('seller')}} -
        <span>{{allDetails.sellerName}}</span>
      </h6>
    </div>
    <div class="order_button" v-if="allDetails.inStock && allDetails.groupDiscount">
      <button type="button" class="large_group_btn single" @click="viaPaytmCashCall(true)">
        {{$t('buyNow')}}
        <br />
        <span>{{$t('priceForsingleBuy', {singlePrice:allDetails.finalPaidAmount})}}</span>
      </button>
      <router-link
        :to="'/group-list/?productId='+ allDetails.productId + '&itemId=' + allDetails.saleReferenceID"
        tag="button"
        type="button"
        class="large_group_btn group"
      >
        {{$t('groupBuy')}}
        <br />
        <span
          v-if="Math.trunc(allDetails.finalPaidAmount - allDetails.groupDiscount) < 0"
        >{{$t('priceForGroupBuy' , {groupPrice:0})}}</span>
        <span
          v-else
        >{{$t('priceForGroupBuy' , {groupPrice:Math.trunc(allDetails.finalPaidAmount - allDetails.groupDiscount)})}}</span>
      </router-link>
    </div>
    <div class="order_button" v-if="allDetails.inStock && !allDetails.groupDiscount">
      <button type="button" class="large_green_btn" @click="viaPaytmCashCall(true)">{{$t('buyNow')}}</button>
    </div>
    <div class="order_button" v-if="allDetails.inStock == false">
      <button type="button" class="large_green_btn order_on_chat" @click="viaPaytmCashCall(true)">{{$t('outOfStock')}}</button>
    </div>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import constant from "../../utils/constant";
import PrdtName from "../ProductDetailSection/ProductDetailTab/PrdtName";
import Color from "../ProductDetailSection/ProductDetailTab/Color";
import AboutProduct from "../ProductDetailSection/ProductDetailTab/AboutProduct";
import ShareAndEarn from "../ProductDetailSection/ProductDetailTab/ShareAndEarn";
import ShareInNetwork from "../ProductDetailSection/ProductDetailTab/ShareInNetwork";
import ProductPolicy from "../ProductDetailSection/ProductDetailTab/ProductPolicy";
import ProductCard from "../HomeSection/ProductCard";
import GroupList from "../ProductDetailSection/ProductDetailTab/GroupList";
import { bus } from "../../main";
import CutThePrice from "../ProductDetailSection/ProductDetailTab/CutThePrice";
import Timer from "../../components/Common/TimeCount";

export default {
  name: "ProductDetailTab",
  props: {
    dataValue: {
      required: true,
      type: Object
    },
    dataStyleAmount: {
      type: Boolean
    }
  },
  components: {
    PrdtName,
    Color,
    AboutProduct,
    ShareAndEarn,
    ShareInNetwork,
    ProductPolicy,
    ProductCard,
    GroupList,
    CutThePrice,
    Timer
  },
  data() {
    return {
      saleReferenceID: null,
      loading: false,
      categoryId: 0,
      pageIndex: 0,
      allDetails: {},
      colorDetails: {},
      sizeDetails: [],
      buttonMsg: "27%",
      color: null,
      size: null,
      xauthid: this.$cookie.get("X-Auth-Id"),
      recommendedProductList: [],
      displayTimeText: "",
      isShowSnackbar: false,
      ApiType: "createPreOrderAgain"
    };
  },
  watch: {
    dataValue() {
      var _this = this;
      this.allDetails = this.dataValue;
      if (this.allDetails) {
        if (this.allDetails.dealDisplayMessage) {
          this.isShowSnackbar = false;
        } else {
          this.isShowSnackbar = true;
        }
        this.$cookie.set("ProductId", this.allDetails.productId);
        this.categoryId = this.allDetails.categoryId;
        this.buttonMsg = `${this.allDetails.onlineDiscount} ₹​ अतिरिक्त छूट`;
        if (this.allDetails.categoryId) {
          this.getSalesListing();
        }      
      }
    }
  },
  methods: {
    getLiveTime(value) {
      let milliseconds = Number(value) / 1000;
      return milliseconds;
    },
    timerStop(obj) {
      if (this.liveData.length > 0) {
        this.liveData[obj.index].status = false;
      }
    },
    applycutprice(cuttheprice_boolean) {
      this.$emit("ENABLACUTPRICE", cuttheprice_boolean);
    },
    StockData(obj) {
      this.allDetails.inStock = obj.stock;
      this.allDetails.finalPaidAmount = obj.finalPaidAmount;
      this.allDetails.mrp = obj.mrp;
    },
    ItemColor(color) {
      this.color = color;
    },
    saleReference_id(value) {
      this.saleReferenceID = value;
    },
    getSalesListing() {
      this.categoryId = this.allDetails.categoryId;
      const obj = {
        categoryId: this.allDetails.categoryId,
        pageIndex: 0,
        saleType: "NORMAL"
      };
      this.$store
        .dispatch({
          type: "getSalesListing",
          payload: obj
        })
        .then(data => {
          this.recommendedProductList = data.data.saleProductDTOs;
        });
    },
    ItemSize(size) {
      this.size = size;
    },
    CheckFields(online) {
      if (
        this.allDetails.selectableAttributes != null &&
        this.allDetails.selectableAttributes.COLOR &&
        this.allDetails.selectableAttributes.COLOR.length > 0
      ) {
        if (this.color) {
          this.checkSize();
        } else {
          let obj = {
            status: this.$t("selectColor"),
            color: "black",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        }
      } else {
        this.checkSize();
      }
    },
    checkSize() {
      if (
        this.allDetails.selectableAttributes != null &&
        this.allDetails.selectableAttributes.SIZE &&
        this.allDetails.selectableAttributes.SIZE.length > 0
      ) {
        if (this.size) {
          this.viaPaytmCashCall(true);
        } else {
          let obj = {
            status: this.$t("selectSize"),
            color: "black",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        }
      } else {
        this.viaPaytmCashCall(true);
      }
    },
    viaPaytmCashCall(online) {
      this.loading = true;
      var obj = {
        saleReferenceID:
          this.saleReferenceID || this.$route.params.saleReferenceID,
        referralUserId: this.allDetails.encodedId,
        size: this.size,
        color: this.color,
        preOrderSource: "ONLINE_FORM"
      };
      if (this.$cookie.get("version-code") > 58) {
        this.ApiType = "createPreOrderAgain";
      } else {
        this.ApiType = "createPreOrder";
      }
      this.$store
        .dispatch({
          type: this.ApiType,
          payload: obj
        })
        .then(data => {
          this.loading = false;
          clevertap.event.push("PRODUCT_BUY_WHATSAPP", {
            ProductName: null,
            saleReferenceID:
              this.saleReferenceID || this.$route.params.saleReferenceID,
            Price: null
          });

          clevertap.event.push("PRODUCT_BUY_ONLINE", {
            ProductName: null,
            saleReferenceID:
              this.saleReferenceID || this.$route.params.saleReferenceID,
            Price: null
          });
          clevertap.event.push("ECOM_CREATE_PRE_ORDER", {
            ProductName: null,
            saleReferenceID:
              this.saleReferenceID || this.$route.params.saleReferenceID
          });
          if (online) {
            if (this.$route.query.source) {
              this.$router.onError(err => {
                if (/loading chunk \d* failed./i.test(err.message)) {
                  window.location.reload();
                }
              });
              this.$router.push(
                "/preOrderDetails/" +
                  data.data.preOrderId +
                  "?source=" +
                  this.$route.query.source
              );
            } else {
              this.$router.onError(err => {
                if (/loading chunk \d* failed./i.test(err.message)) {
                  window.location.reload();
                }
              });
              this.$router.push("/preOrderDetails/" + data.data.preOrderId);
            }
          } else {
            window.location.href = data.data.orderOnWhatsapp;
          }
        })
        .catch(err => {
          if (err.response.data.message == "PRODUCT_IS_OUT_OF_STOCK") {
            this.loading = false;
            this.emitToaster("ItemOutStock");
          } else if (
            err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
            err.response.data.message ==
              "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
          ) {
            try {
              _JWT.refereshToken = res => {
                if (res != "fail") {
                  this.$cookie.set("JWT-TOKEN", res);
                  this.ApiType = "createPreOrderAgain";
                  this.viaPaytmCashCall(true);
                } else {
                  this.loading = false;
                  this.emitToaster("Something went wrong! Try Again Later");
                }
              };
              JSBridgePlugin.refreshTokens("_JWT.refereshToken");
            } catch (err) {
              this.loading = false;
              console.log(err);
            }
          } else {
            this.loading = false;
            this.emitToaster("Failure");
          }
        });
    },
    emitToaster(status) {
      let obj = {
        status: status,
        timeoutMs: "5000"
      };
      bus.$emit("apiStatus", obj);
    },
  
  },
  mounted() {
    var _this = this;
    this.saleReferenceID = this.$route.params.saleReferenceID;
    this.allDetails = this.dataValue;
    if (this.allDetails) {
      if (this.allDetails.dealDisplayMessage) {
        this.isShowSnackbar = false;
      } else {
        this.isShowSnackbar = true;
      }
      this.categoryId = this.allDetails.categoryId;
      this.buttonMsg = `${this.allDetails.onlineDiscount} ₹​ अतिरिक्त छूट`;
      if (this.allDetails.categoryId) {
        this.getSalesListing();
      }
    }
  }
};
</script>
    